import {useIntl} from 'react-intl'
import {Table} from 'src/feature/bite/component/Table'
import {getDateAndTime} from 'src/feature/bite/helpers/date'
import {useMember} from 'src/feature/members/hook'
import FilterDrawerMarketing from '../../List/FilterDrawerMarketing'
import {useState} from 'react'

const EmailEngagement = ({loading}: {loading: boolean}) => {
  const intl = useIntl()
  const {detailTab, detailTabSet} = useMember()
  const [open, setOpen] = useState(false)

  const data = detailTab?.EmailEngagement?.dataList || []
  const paging = detailTab?.EmailEngagement?.paging || {
    currentPageNumber: 0,
    totalPagesNumber: 0,
    pageSize: 0,
    totalCount: 0,
  }

  // const Columns = [
  //   /* {
  //     key: 'EmailAddress',
  //     dataIndex: 'emailAddress',
  //     title: intl.formatMessage({ id: 'MEMBER.DETAIL.MAIL.EMAIL' }),
  //   }, */
  //   {
  //     key: 'Title',
  //     dataIndex: 'title',
  //     title: intl.formatMessage({id: 'MEMBER.DETAIL.MAIL.TITLE'}),
  //   },
  //   {
  //     key: 'status',
  //     dataIndex: 'status',
  //     title: intl.formatMessage({id: 'MEMBER.DETAIL.MAIL.STATUS'}),
  //     status: true,
  //   },
  //   {
  //     key: 'SentTime',
  //     dataIndex: 'sentTime',
  //     title: intl.formatMessage({id: 'MEMBER.DETAIL.MAIL.SENT_TIME'}),
  //     render: (text: string) => <>{getDateAndTime(text)}</>,
  //   },
  //   {
  //     key: 'DeliveryTime',
  //     dataIndex: 'deliveryTime',
  //     title: intl.formatMessage({id: 'MEMBER.DETAIL.MAIL.DELIVERY_TIME'}),
  //     render: (text: string) => <>{getDateAndTime(text)}</>,
  //   },
  //   {
  //     key: 'Opened',
  //     dataIndex: 'read',
  //     title: intl.formatMessage({id: 'MEMBER.DETAIL.MAIL.OPENED'}),
  //     render: (text: string) => {
  //       const status = text ? 'success' : 'danger'
  //       return (
  //         <div className={`text-${status}`}>
  //           {text ? intl.formatMessage({id: 'YES'}) : intl.formatMessage({id: 'NO'})}
  //         </div>
  //       )
  //     },
  //   },
  //   {
  //     key: 'OpenedTime',
  //     dataIndex: 'readTime',
  //     title: intl.formatMessage({id: 'MEMBER.DETAIL.MAIL.OPENED_TIME'}),
  //     render: (text: string) => <>{getDateAndTime(text)}</>,
  //   },
  //   {
  //     key: 'Message',
  //     dataIndex: 'message',
  //     title: intl.formatMessage({id: 'MEMBER.DETAIL.MAIL.MESSAGE'}),
  //     render: (text: string) => <>{text?.slice(0, 30)}...</>,
  //   },
  //   {
  //     key: 'Sender',
  //     dataIndex: 'sender',
  //     title: intl.formatMessage({id: 'MEMBER.DETAIL.MAIL.SENDER'}),
  //   },
  //   {
  //     key: 'result',
  //     dataIndex: 'result',
  //     title: intl.formatMessage({id: 'MEMBER.DETAIL.MAIL.RESULT'}),
  //     render: (text: string) => {
  //       return (
  //         <>
  //           <div className={`text-${text === 'Success' ? 'success' : 'danger'}`}>{text}</div>
  //         </>
  //       )
  //     },
  //   },
  // ]

  const Columns = [
    {
      key: 'Title',
      dataIndex: 'subject',
      title: intl.formatMessage({id: 'STORE.DETAIL.MAIL.TITLE'}),
    },
    {
      key: 'status',
      dataIndex: 'status',
      title: intl.formatMessage({id: 'STORE.DETAIL.MAIL.STATUS'}),
      mailSent: true,
    },
    {
      key: 'SentTime',
      dataIndex: 'sentTime',
      title: intl.formatMessage({id: 'STORE.DETAIL.MAIL.SENT_TIME'}),
      render: (text: string) => <>{getDateAndTime(text)}</>,
    },
    {
      key: 'DeliveryTime',
      dataIndex: 'deliveryTime',
      title: intl.formatMessage({id: 'STORE.DETAIL.MAIL.DELIVERY_TIME'}),
      render: (text: string) => <>{getDateAndTime(text)}</>,
    },
    {
      key: 'Opened',
      dataIndex: 'readTime',
      title: intl.formatMessage({id: 'STORE.DETAIL.MAIL.OPENED'}),
      render: (text: string) => {
        return <div className={`text-success`}>{intl.formatMessage({id: 'YES'})}</div>

        // return (
        //   <div className={`text-${status}`}>
        //     {text ? intl.formatMessage({id: 'YES'}) : intl.formatMessage({id: 'NO'})}
        //   </div>
        // )
      },
    },
    {
      key: 'OpenedTime',
      dataIndex: 'readTime',
      title: intl.formatMessage({id: 'STORE.DETAIL.MAIL.OPENED_TIME'}),
      render: (text: string) => <>{getDateAndTime(text)}</>,
    },
    {
      key: 'Message',
      dataIndex: 'message',
      title: intl.formatMessage({id: 'STORE.DETAIL.MAIL.MESSAGE'}),
      render: (text: string) => (
        <span>{text ? `${text?.replace(/<[^>]*>?/gm, '').slice(0, 30)}...` : '-'}</span>
      ),
    },
    {
      key: 'Sender',
      dataIndex: 'sender',
      title: intl.formatMessage({id: 'STORE.DETAIL.MAIL.SENDER'}),
    },
    {
      key: 'CreatedOn',
      dataIndex: 'createdOn',
      title: intl.formatMessage({id: 'STORE.DETAIL.MAIL.CREATED_ON'}),
      render: (text: string) => <>{getDateAndTime(text)}</>,
    },
  ]

  return (
    <>
      <FilterDrawerMarketing setOpen={setOpen} open={open} />
      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header'>
          <div className='card-title m-0'>
            <div>
              <h3 className='fw-bold mb-2 mt-5'>
                {intl.formatMessage({id: 'MEMBER.DETAIL.EMAIL_ENGAGEMENT'})}
              </h3>
              <p className=' fw-normal fs-6'>
                {intl.formatMessage({id: 'MEMBER.DETAIL.EMAIL_ENGAGEMENT_TOOLTIP'})}
              </p>
            </div>
          </div>
          <div className='card-toolbar'>
            <div className='d-flex justify-content-end' data-kt-customer-table-toolbar='base'>
              <div className='d-flex align-items-center gap-2 gap-lg-3'>
                <button
                  className='btn btn-light'
                  onClick={() => setOpen(true)}
                  // id='kt_filter_membertrx_button'
                >
                  <i className='bi bi-sliders fs-4 me-4'></i>
                  {intl.formatMessage({id: 'GLOBAL.FILTER'})}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className='card-body pt-0'>
          <Table
            loading={loading}
            dataSource={data}
            columns={Columns}
            pagination={{
              current: paging.currentPageNumber,
              pageSize: paging.pageSize,
              total: paging.totalCount,
              onChange: (page: any) => {
                if (!detailTab || !detailTab.EmailEngagement) return
                const {pageSize, current} = page
                const currentPage =
                  pageSize !== detailTab.EmailEngagement.paging.pageSize ? 1 : current

                detailTabSet({
                  ...detailTab,
                  EmailEngagement: {
                    ...detailTab.EmailEngagement,
                    paging: {
                      ...paging,
                      currentPageNumber: currentPage,
                      pageSize: pageSize,
                    },
                  },
                })

                // if (!detailTab || !detailTab.EmailEngagement) return;
                // detailTabSet({
                //   ...detailTab, EmailEngagement: {
                //     ...detailTab.EmailEngagement, paging: {
                //       ...paging, currentPageNumber: page.current,
                //       pageSize: page.pageSize,
                //     }
                //   }
                // });
              },
            }}
          />
        </div>
      </div>
    </>
  )
}

export default EmailEngagement
